webpackJsonp([35783957827783],{

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data,
	      transition = _ref.transition;
	  return _react2.default.createElement(
	    'div',
	    { style: transition && transition.style },
	    _react2.default.createElement(
	      'div',
	      { className: 'home_page_top' },
	      _react2.default.createElement(
	        'div',
	        { className: 'home_intro' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'pages_head' },
	          'I am'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'a ',
	          _react2.default.createElement(
	            'span',
	            { className: 'highlight_about' },
	            'Developer'
	          ),
	          ' and ',
	          _react2.default.createElement(
	            'span',
	            { className: 'highlight_about' },
	            'Designer'
	          ),
	          ' with more than ',
	          _react2.default.createElement(
	            'span',
	            { className: 'highlight_about' },
	            '12 years experience'
	          ),
	          ' creating and maintaining websites, HTML email campaigns, print publications, general print collateral, branding assets and analytics that support the business goals of organizations that I\u2019ve served with, founded and worked for.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'home_write_list' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Recent Posts'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          data.allMarkdownRemark.edges.map(function (post) {
	            return _react2.default.createElement(
	              'li',
	              { key: post.node.id },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: post.node.frontmatter.path },
	                post.node.frontmatter.title
	              )
	            );
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'home_page_bottom' },
	      _react2.default.createElement(
	        'div',
	        { className: 'home_learning_list' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Currently Learning More About'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          data.allLearningnowJson.edges.map(function (learning) {
	            return _react2.default.createElement(
	              'li',
	              { key: learning.node.id },
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', rel: 'nofollow noopener', href: learning.node.url },
	                learning.node.name
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = IndexPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-86390cc2f5a7a1988584.js